import { type ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

import { MantineProvider, type MantineThemeOverride } from '@mantine/core';

import { mantineTheme } from '@bcc-life/sandbox/assets';

/** Unit linked has its own look: the same base theme with Suisse instead of Inter. */
const unitLinkedTheme: MantineThemeOverride = {
  ...mantineTheme,
  fontFamily: 'var(--font-suisse)',
  fontFamilyMonospace: 'var(--font-suisse), monospace',
};

export default function CabinetMantineProvider({ children }: { children?: ReactNode }) {
  const { pathname } = useLocation();
  const isUnitLinked = pathname === '/unit-linked' || pathname.startsWith('/unit-linked/');

  return (
    <MantineProvider
      defaultColorScheme="light"
      forceColorScheme={isUnitLinked ? undefined : 'light'}
      theme={isUnitLinked ? unitLinkedTheme : mantineTheme}
    >
      {children}
    </MantineProvider>
  );
}
